export const serverApplicationTabs = [
  { label: "Environments", slug: "environments" },
  { label: "Builds", slug: "builds" },
  { label: "Deploys", slug: "deploys" },
  { label: "Settings", slug: "settings" },
] as const;

export type ServerApplicationTabItem = (typeof serverApplicationTabs)[number]["slug"];

export const runnableApplicationTabs = [
  { label: "Jobs", slug: "jobs" },
  { label: "Settings", slug: "settings" },
] as const;

export type RunnableApplicationTabItem = (typeof runnableApplicationTabs)[number]["slug"];
